import React from 'react';

const TermsConditions = () => {
  return (
    <div className="min-h-screen pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h1 className="text-2xl md:text-4xl font-bold text-white mb-4">Termini e Condizioni</h1>
          <p className="text-gray-400 text-sm md:text-base">Condizioni generali di utilizzo del servizio BeautyKit</p>
        </div>

        <div className="bg-black rounded-xl p-6 md:p-8 space-y-6 text-gray-300">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Accettazione dei Termini</h2>
            <p className="text-sm md:text-base leading-relaxed">
              L'utilizzo del servizio BeautyKit implica l'accettazione integrale dei presenti termini e condizioni. 
              Se non si accettano questi termini, non utilizzare il servizio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Servizio Offerto</h2>
            <p className="text-sm md:text-base leading-relaxed">
              BeautyKit è un servizio di personalizzazione skincare che permette di comporre kit cosmetici personalizzati 
              attraverso il Kit Mix Live, scegliendo i 5 vasetti in base a preferenze e obiettivi individuali.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Obblighi dell'Utente</h2>
            <p className="text-sm md:text-base leading-relaxed">
              L'utente si impegna a fornire informazioni veritiere, utilizzare il servizio in modo appropriato e 
              rispettare i diritti di proprietà intellettuale di Lamoni Lab S.r.l.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Limitazioni di Responsabilità</h2>
            <p className="text-sm md:text-base leading-relaxed">
              I consigli forniti hanno carattere generale e non sostituiscono il parere di un dermatologo. 
              Lamoni Lab S.r.l. non è responsabile per eventuali reazioni avverse ai prodotti consigliati.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
